import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";

export const PassengerTypesPage: FC = () => {
  return (
    <PageContextWrapper entity="passengerType">
      <PageClientSideFilters />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
